<!DOCTYPE HTML>
<template>
<div class="progress-indicator">

  <CloseButton @close="exit" />

  <span class="label">Question {{progress.value + 1}} of {{progress.max}}</span>

  <b-progress :value="progress.value"
              variant="primary"
              :max="progress.max"
              class="my-2" />


</div>
</template>

<script>
import CloseButton from '@/components/CloseButton.vue'
export default {
  name: 'Progress',
  components: {
    CloseButton
  },
  props: {
    progress: Object
  },
  computed: {},
  methods: {
    exit() {
      this.$emit( 'exit' )
    }
  },
  data() {
    return {}
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "@/styles/overrides.scss";

.progress-indicator {
    display: grid;
    grid-auto-flow: column;
    grid-template-columns: auto auto 5rem;
    justify-content: flex-start;
    grid-column-gap: 1rem;
    align-items: center;
    align-content: center;

    .label {
        text-transform: uppercase;
        font-weight: bold;
        font-size: 0.8rem;
        color: $primary;
    }

    .progress {
        height: 0.5rem;
    }
}
</style>
